module.exports = __webpack_public_path__ + "static/ad-f54a24d29bcaa41e713b5fdef95414de.svg";